"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardPage = LeaderboardPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var letsachieve_1 = require("../../../../api/letsachieve");
var pageHeader_1 = require("../../../../components/pageHeader");
var routes_1 = require("../../../../constants/routes");
var console_1 = require("../../../../reducers/slices/console");
var constants_1 = require("../statistics/constants");
var leaderboard_standings_1 = require("./components/leaderboardStandings/leaderboard_standings");
function LeaderboardPage() {
    var statistic_id = (0, react_router_dom_1.useParams)().statistic_id;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, letsachieve_1.useGetStatisticQuery)(statistic_id !== null && statistic_id !== void 0 ? statistic_id : "", { skip: !statistic_id }), statistic = _a.data, isLoading = _a.isLoading, isError = _a.isError;
    (0, react_3.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)(statistic ? "Leaderboard - ".concat(statistic.name) : "Leaderboard"));
    }, [statistic, dispatch]);
    var back = { label: "Back to leaderboards", on_press: function () { return navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.LEADERBOARDS_ROUTE)); } };
    if (isLoading)
        return (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "lg" });
    if (!statistic_id || isError || !statistic) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center justify-center gap-4 py-16", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:alert-circle", className: "text-4xl text-danger" }), (0, jsx_runtime_1.jsx)("p", { className: "text-lg font-semibold", children: "This leaderboard could not be loaded." }), (0, jsx_runtime_1.jsx)(pageHeader_1.BackButton, __assign({}, back))] }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(pageHeader_1.PageHeader, { back: back, icon: "solar:ranking-linear", title: statistic.name, status: { label: "v".concat(statistic.version), color: "accent" }, meta: [
                    { icon: "solar:calculator-linear", label: statistic.aggregation_method },
                    { icon: "solar:restart-linear", label: (0, constants_1.resetIntervalLabel)(statistic.reset_interval) },
                ], actions: (0, jsx_runtime_1.jsxs)(react_1.Button, { size: "sm", variant: "tertiary", onPress: function () { return navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.STATISTICS_ROUTE, "/").concat(statistic._id)); }, children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:chart-bar", width: 18 }), "Open statistic"] }) }), (0, jsx_runtime_1.jsx)(leaderboard_standings_1.LeaderboardStandings, { statistic_id: statistic._id })] }));
}
